/* eslint-disable no-undef -- globalThis is ES2020; CRA eslint env does not declare it by default */
const browserGlobal = typeof globalThis !== 'undefined' ? globalThis : window;

export default browserGlobal;
